import { CITIES } from "../lib/site";

export default function IndiaMap({ className = "" }) {
  return (
    <svg
      viewBox="0 0 400 460"
      className={className}
      fill="none"
      role="img"
      aria-label="Stylised map of India showing cities Saarthva serves"
      data-testid="india-map"
    >
      <path
        d="M150 15 L185 35 L205 62 L226 55 L252 76 L292 86 L330 96 L366 120 L376 142 L340 152 L316 172 L321 192 L290 202 L270 226 L260 256 L240 286 L225 320 L200 360 L186 400 L173 436 L160 402 L150 362 L130 322 L110 286 L95 252 L70 230 L46 202 L30 176 L55 166 L60 140 L85 126 L95 100 L120 80 L135 50 Z"
        fill="rgba(37,99,235,0.08)"
        stroke="#2563EB"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {CITIES.map((city, i) => (
        <g key={city.name}>
          <circle
            cx={city.x}
            cy={city.y}
            r="5"
            fill="#F97316"
            fillOpacity="0.55"
            className="map-ping"
            style={{ animationDelay: `${(i % 7) * 0.38}s` }}
          />
          <circle cx={city.x} cy={city.y} r="3" fill="#F97316" />
          {city.major && (
            <text x={city.x + 9} y={city.y + 3.5} fill="#CBD5E1" fontSize="9.5" fontFamily="'JetBrains Mono', monospace" letterSpacing="0.5">
              {city.name}
            </text>
          )}
        </g>
      ))}
    </svg>
  );
}
